import { initSearchInput } from "./search-input";
import { initTabs } from "./tabs";

initSearchInput();
initTabs();
